module.exports = __webpack_public_path__ + "img/the-netherlands-colorectal-cancer-female.c12525b2.png";